export const paddingLeft = (num, length = 2) => {
  num = "" + num;

  for (; num.length < length; ) {
    num = "0" + num;
  }
  return num;
};

export const paddingRight = (num, length = 2) => {
  num = "" + num;

  for (; num.length < length; ) {
    num += "0";
  }
  return num;
};

export const buildQuery = data => {
  return Object.keys(data)
    .filter(key => data[key] != null)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
};

export const buildQueryParams = (obj, prefix = '') => {
  const query = Object.keys(obj).map((key) => {
    const value = obj[key];
    const prefixedKey = prefix ? `${prefix}[${key}]` : key;
    
    if (typeof value === 'object' && value !== null) {
      if (Array.isArray(value)) {
        return value.map((val, index) => {
          return buildQueryParams({ [index]: val }, prefixedKey);
        }).join('&');
      } else {
        return buildQueryParams(value, prefixedKey);
      }
    } else {
      return `${encodeURIComponent(prefixedKey)}=${encodeURIComponent(value)}`;
    }
  });

  return query.join('&');
}

export const formatDate = date =>
  `${date.getFullYear()}-${paddingLeft(date.getMonth() + 1)}-${date.getDate()}`;

export const truncateMinute = date => {
  const ret = new Date(date.getTime());
  ret.setSeconds(0);
  ret.setMilliseconds(0);
  return ret;
};

export const addMinutes = (date, deltaMinutes) => {
  const ret = new Date(date.getTime());
  ret.setMinutes(ret.getMinutes() + deltaMinutes);
  return ret;
};

export const addDate = (date, deltaDate) => {
  const ret = new Date(date.getTime());
  ret.setDate(ret.getDate() + deltaDate);
  return ret;
};

export const formatMoneyRange = range => {
  if (range.from === range.to) {
    return formatMoney(range.to);
  } else {
    return formatMoney(range.from) + "-" + formatMoney(range.to);
  }
};

export const formatNumber = num => {
  let ret = "" + num;
  const dotIndex = ret.indexOf(".");
  if (dotIndex === -1) {
    return ret + ".00";
  } else {
    return (
      ret.substring(0, dotIndex) +
      "." +
      paddingRight(ret.substring(dotIndex + 1, dotIndex + 3), 2)
    );
  }
};

export const formatMoney = num => {
  return "$" + formatNumber(num);
};

export function translateToMins(duration, m, h) {
  let durationValue = duration;
  if (isNaN(duration)) {
    durationValue = 0;
  }
  const hours = Math.floor(durationValue / 60 / 60 / 1000);
  if (hours === 0) {
    return quickPlural(Math.floor(durationValue / 60 / 1000), m);
  } else {
    const mod = durationValue - hours * 60 * 60 * 1000;
    return (
      (hours === 0 ? "" : quickPlural(hours, h) + " ") +
      quickPlural(Math.floor(mod / 60 / 1000), m)
    );
  }
}

const quickPlural = (count, noun) => {
  if (noun.length === 1) {
    return `${count}${noun}`;
  }

  if (count === 1) {
    return `${count} ${noun}`;
  }
  return `${count} ${noun}s`;
};

export const customRequiredPhoneCharactersMapping = {
  'HK': 8,
  'CA': 10,
  'US': 10
}
const countriesNotTreatedAsInternational = {
  'US': true,
  'CA': true,
}
const localesNotTreatedAsInternational = {
  'en': true,
  'ca': true,
  'en-CA': true
}

export const requiredPhoneNumberLengthForCountry = (country) => {
  return customRequiredPhoneCharactersMapping[country] || 6 // backwards compatibility
}

export const isLocaleOrCountryInternational = (localeUUID, country) => {
  if (localesNotTreatedAsInternational[localeUUID] && countriesNotTreatedAsInternational[country]) {
    return false
  }
  return true
}